
<template>
  <div class='pdf'>
    <pdf-components v-if="showpdf===true" />
    <div class="noPdf" v-else><div>笔录已结束,</div><div>你已无权查看相关案情文件！</div></div>
    <!-- <div>
      <el-card class="qianming-container" body-style="padding:0px">
        <vue-esign ref="esign" :isCrop="isCrop" :width="350" :height="200" :lineWidth="lineWidth" :lineColor="lineColor" bgColor="#fff" :isClearBgColor="false" v-if="flag"></vue-esign>
        <div class="card" v-else></div>
        <div class="contro-container">
          <el-button type="primary" @click="flag =true">开始签名</el-button>
          <el-button type="danger" @click="handleReset">清空</el-button>
          <el-button type="primary" @click="handleGenerate">确认</el-button>
        </div>
      </el-card>
    </div> -->
    <div class="handwritten-name-wrap">
      <div class="btn" v-if="flagSign">
        <el-button type="primary" @click.native="handleClick">
          输入电子签名
        </el-button>
        <!-- <el-button type="success" @click="handleGenerate" size="small">
          提交
        </el-button> -->
      </div>
      <!-- <div class="img-wrap">
        <img :src="imgSrc" alt="" v-if="imgSrc">
      </div> -->
      <div class="opdia">
        <el-dialog custom-class='dia' :visible.sync="panelVisible" title="手写签名" width="100%" :destroy-on-close="true" class="signNameModel" top="0">
          <template slot="title">
            <div>
              <p>手写签名</p>
              <div class="gtnGroup">
                <!-- <el-button type="primary" size="mini" @click="undo">撤销</el-button> -->
                <el-button type="primary" size="mini" @click="save">提交</el-button>
              </div>
            </div>
          </template>
          <template>
            <el-dialog width="80%" class="submitModel" title="确认签名" :visible.sync="submitVisible" append-to-body>
              <img :src="imgSrc" alt="">
              <p>签名提交后,不允许修改,您确定提交签名吗?</p>
              <div slot="footer" class="dialog-footer">
                <el-button @click="submitVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleGenerate">确认</el-button>
              </div>
            </el-dialog>
            <!-- <div class="otherSet">
            <div class="penTxt">笔刷大小：</div>
            <div class="circleWrap" :class="{ active: isActive1 }" @click="selSize(1)"><b class="b1"></b></div>
            <div class="circleWrap" :class="{ active: isActive2 }" @click="selSize(2)"><b class="b2"></b></div>
            <div class="circleWrap" :class="{ active: isActive3 }" @click="selSize(3)"><b class="b3"></b></div>
          </div> -->
            <div class="signWrap" @touchmove.prevent>
              <div class="signBox">
                <p> 此处手写输入（以上笔录属实）<el-button type="danger" size="mini" @click="clear">清空信息</el-button></p>
                <el-row class="mainBox">
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign1" :options="options" class="placeholderText" />
                  </el-col>
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign2" :options="options" class="placeholderText1" />
                  </el-col>
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign3" :options="options" class="placeholderText2" />
                  </el-col>
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign4" :options="options" class="placeholderText3" />
                  </el-col>
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign5" :options="options" class="placeholderText4" />
                  </el-col>
                  <el-col :span="8">
                    <VueSignaturePad width="100%" height="100%" ref="sign6" :options="options" class="placeholderText5" />
                  </el-col>
                </el-row>
              </div>
              <!-- <el-divider><i class="el-icon-mobile-phone"></i></el-divider> -->
              <!-- <el-divider></el-divider> -->
              <div class="signBox lastBox">
                <p> 此处签名<el-button type="danger" size="mini" @click="clearSign">清空签名</el-button></p>
                <VueSignaturePad width="100%" height="95%" ref="signature" :options="options" class="placeholderText7" />
              </div>

              <!-- <footer>
              

            </footer> -->
              <!-- <img :src="imgSrc" alt=""> -->
            </div>
          </template>

        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import PdfComponents from './components/pdf.vue'
import { getfile, getMsg } from "@/api";
export default {
  components: {
    PdfComponents
  },
  data () {
    return {
      isCrop: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      caseid: this.$route.query.caseid,
      flag: false,
      panelVisible: false,
      submitVisible: false,
      panelTitle: "",
      options: {
        penColor: "#000",
        minWidth: 2,    //控制画笔最小宽度
        maxWidth: 2,    //控制画笔最大宽度
      },
      isActive1: true,
      isActive2: false,
      isActive3: false,
      imgSrc: "",
      list: [1, 2, 3, 4, 5, 6],
      flagSign: true,
      showpdf:true
      // loading: false
    };
  },
  created () {
    this.init()
  },
  mounted () {

  },
  methods: {
    // 判断是否已签名
    init () {
      getMsg(this.$route.query.caseid).then(res => {
        if (res&&res.data.recordPO.status==2) {
          this.flagSign = false,
          this.showpdf=false
        }
        console.log('res', res.data.recordPO.status)
        // if (res.data.recordPO && res.data.recordPO.signUrl) {
        //   this.flagSign = false
        // }
      })
    },
    //清空画板..
    handleReset () {
      this.$refs.esign.reset();
      this.resultImg = "";
    },
    //生成签名图片..
    async handleGenerate () {
      if (this.imgSrc) {
        let randnum = Math.random() * 10000000000000;
        randnum = Math.floor(randnum);
        let fileName = "dianziqianming/" + randnum + ".png";
        let file = await this.dataURLtoFile(this.imgSrc, fileName);
        console.log(file);
        let formdata = new FormData()
        formdata.append('file', file, fileName)
        // console.log('params :>> ', params);
        getfile([this.caseid, formdata]).then(res => {
          if (res && res.code === 200) {
            // console.log(111);
            this.$message.success("签名上传成功");
            this.submitVisible = false
            this.panelVisible = false;

            this.$router.go(0)
          } else {
            this.$message.error(res.message)
            this.submitVisible = false
            this.panelVisible = false;
          }
        }).catch(err => {
          console.log(err);
          this.submitVisible = false
          this.panelVisible = false;
        })
      } else {
        this.$message.error('请签名之后提交！')
      }
    },
    //将base64转换为文件..
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    //手写签名按钮的点击
    handleClick () {
      this.panelVisible = true;
      // this.isActive1 = true;
      // this.isActive2 = false;
      // this.isActive3 = false;
      this.options = {
        penColor: "#000",
        minWidth: 2,
        maxWidth: 2,
      }
    },
    //撤销
    undo () {
      this.$refs.signaturePad.undoSignature();
    },
    //清除
    clear () {
      // this.$refs.signaturePad.clearSignature();
      this.list.map(el => {
        this.$refs[`sign${el}`].clearSignature()
      })
    },
    // 清楚签名
    clearSign () {
      this.$refs.signature.clearSignature();
    },
    //保存
    // async save () {
    //   // console.log(this.$refs.signaturePad.saveSignature());
    //   const data1 = this.$refs.signaturePad.saveSignature().data;
    //   // console.log('data :>> ', data);
    //   // this.imgSrc = await data;
    //   const data2 = this.$refs.signature.saveSignature().data
    //   this.drawAndShareImage(data1, data2)
    //   // this.handleGenerate()
    // },

    async save () {
      let canvas = document.createElement('canvas');
      canvas.width = 480;
      canvas.height = 440;
      let context = canvas.getContext('2d');
      context.rect(0, 0, canvas.width, canvas.height);
      const a = this.list.every(el => this.$refs[`sign${el}`].saveSignature().data)
      if (!a) {
        this.$message.error('请完整填写')
        return
      }
      if (!this.$refs.signature.saveSignature().data) {
        this.$message.error('请签名')
        return
      }
      // console.log('a :>> ', a);
      await this.list.map((el, index) => {
        // console.log('index :>> ', index);
        const bgImg = new Image()
        bgImg.src = this.$refs[`sign${el}`].saveSignature().data
        bgImg.crossOrigin = 'Anonymous'
        bgImg.onload = () => {
          context.drawImage(bgImg, index * 80, 0, 80, 200);
        }
      })
      // let bgImg = new Image();
      // bgImg.src = bgsrc;    // 背景图的url
      // bgImg.crossOrigin = 'Anonymous';
      // bgImg.onload = () => {
      //   context.drawImage(bgImg, 0, 0, 300, 220);
      // if (this.$refs.signature.saveSignature().data) {
      let img = new Image();
      img.src = this.$refs.signature.saveSignature().data;    // 需要合进去的图片url
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        context.drawImage(img, 100, 240, 300, 220);
        let base64 = canvas.toDataURL('image/png');
        // console.log(base64); // 这个就是合成后的图片链接，如果需要上传请查看我另外的文章
        this.imgSrc = base64
        // this.handleGenerate()
        this.submitVisible = true
      }
      // } else {
      //   this.$message.error('请签名')
      // }
      // }
    },
    //调节画笔粗细大小
    selSize (val) {
      this.options = {
        penColor: "#000",
        minWidth: val,
        maxWidth: val,
      };
      if (val == 1) {
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
      } else if (val == 2) {
        this.isActive1 = false;
        this.isActive2 = true;
        this.isActive3 = false;
      } else if (val == 3) {
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.pdf {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noPdf{
width: 100%;
text-align: center; 
  position: fixed;
  // writing-mode:vertical-rl;
  font-size: 24px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // transform: translateY(-50%);
}
.placeholderText {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/1.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText1 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/2.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText2 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/3.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText3 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/4.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText4 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/5.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText5 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/6.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 70%;
}
.placeholderText7 {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/7.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 80%;
}
// ::v-deep .dia {
//   height: 80% !important;
// }
// .qianming-container {
//   width: 100vw;
//   height: 40vh;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   box-sizing: border-box;
//   padding: 10px;
//   background: #efefef;
//   .contro-container {
//     width: 350px;
//     height: 50px;
//     display: flex;
//     // flex-direction: row;
//     align-items: center;
//     justify-content: space-around;
//     background-color: rgb(230, 230, 230);
//   }
//   // margin: 20px auto;
//   // position: relative;
// }
// .text {
//   font-size: 14px;
// }
// .item {
//   margin-bottom: 18px;
// }
// .card {
//   height: 200px;
//   width: 100%;
//   background: #fff;
// }
.handwritten-name-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  border-top: 2px dotted rgb(231, 230, 230);
  .btn {
    .el-button {
      // margin-bottom: 10px;
      padding: 12px 30px;
      font-size: 18px;
    }
  }
  .img-wrap {
    width: 100%;
    // height: 164px;
    height: 15vh;
    margin-left: 5px;
    border: 1px solid #ccc;
    img {
      width: 80%;
      height: 100%;
    }
  }
  ::v-deep .el-dialog {
    margin: 0;
  }
  ::v-deep .el-dialog__wrapper {
    overflow: hidden !important;
  }
  ::v-deep .signNameModel {
    // height: 100vh;
    // .el-dialog {
    //   // height: 100%;
    //   // margin: 0 !important;
    // }

    .el-dialog__header {
      padding: 10px;
      border-bottom: 1px solid rgb(205, 205, 205);
      .el-dialog__headerbtn {
        top: 15px;
      }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 50px;
        p {
          font-size: 16px;
          font-weight: bold;
          // margin-right: 100px;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      height: 90%;
      .otherSet {
        // width: 50%;
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // .penTxt {
        //   // width: 70px;
        // }
        .selSize {
          width: 70px;
        }
        .el-select__caret {
          position: absolute;
          right: -3px;
        }
        .b1,
        .b2,
        .b3 {
          display: inline-block;
          background: #000;
          border-radius: 50%;
        }
        .circleWrap {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          cursor: pointer;
          margin-right: 20px;
        }
        .active {
          border: 1px dashed #0074d9;
        }
        .b1 {
          width: 4px;
          height: 4px;
        }
        .b2 {
          width: 6px;
          height: 6px;
        }
        .b3 {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
  .signWrap {
    // height: 100%;overflow.
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // border-top: 1px dotted rgb(231, 230, 230);
    .signBox {
      height: 50vh;
      margin-top: 5px;
      > p {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        .el-button {
          margin-left: 10px;
        }
      }
      // box-shadow: 1px 1px 5px 1px rgb(179, 179, 179);
      // border-top: 1px dotted rgb(179, 179, 179);
      // border-bottom: 1px dotted rgb(179, 179, 179);
      .mainBox {
        margin-top: 10px;
        height: 90%;
        .el-col {
          height: 50%;
          box-sizing: border-box;
          border: 1px dotted #999;
          border-left: none;
        }
        .el-col:nth-of-type(3n) {
          border-right: none;
        }
        .el-col:nth-of-type(1),
        .el-col:nth-of-type(2),
        .el-col:nth-of-type(3) {
          border-bottom: none;
        }
        // display: flex;
        // flex-wrap: w;
      }
    }
    .lastBox {
      height: 32vh;
      > p {
        border-bottom: 1px dotted rgb(179, 179, 179);
      }
    }
    .signName {
      flex: 1;
      border-top: 1px solid #ccc;
    }
    footer {
      // height: 40px;
      padding: 10px;
      border-top: 1px solid #ccc;
      .gtnGroup {
        // width: 50%;
        display: flex;
        justify-content: flex-end;
        // margin-left: 20px;
      }
    }
  }
}
// .signNameModel {
//   .vxe-modal--content {
//     padding: 0 !important;
//   }
// }
</style>
